<template>
  <div>
    <!-- <div class="AdPadTest">
      <img class="AdPadTestImage" src="https://tpc.googlesyndication.com/simgad/5675076390026035573">
    </div> -->
    <Ads
      class="mobHide"
      :page="'home'"
      :adNum="'top'"
      :mob="false"
      :side="false"
    />
    <Ads
      class="mobShow"
      :page="'home'"
      :adNum="'top'"
      :mob="true"
      :side="false"
    />
    <!-- <div :class="{ spacer: takeOver === true }"></div> -->
    <div class="home" :class="{ container: takeOver === true, nopadMod :takeOver === true   }">
      <div class="homeBottom">
        <div id="slider">
          <Slider
            :posts="posts"
            :season="season"
            :course="course"
            :report="report"
            :title="title"
            :takeover="takeOver"
            :config="config"
            :page="'home'"
            :adNum="'top'"
          />
        </div>
        <b-container class="nocon" v-if="showbutton && tourSelect.LET == 'Y'">
          <template>
            <div class="">
              <template v-if="pollsource == 'B' || pollsource == 'W' && pollgeneral == 'Y'">
                <template v-if="pollappImage != ''">
                  <template v-if="pollType == 'E'">
                    <b-link @click="pollTypeEclick">
                      <img class="appImage pulse" :src="pollappImage">
                    </b-link>
                  </template>
                  <template v-else>
                    <img class="appImage pulse" v-b-modal.modal-xl :src="pollappImage">
                  </template>
                </template>
                <template v-else>
                  <template v-if="pollType == 'E'">
                    <!-- <b-link :href="pollTypeLink" target="_blank"> -->
                    <b-link @click="pollTypeEclick">
                      <b-button variant="success" class="pulse leftPulse"> Vote for Player of the Month</b-button>
                    </b-link>
                  </template>
                  <template v-else>
                    <b-button v-b-modal.modal-xl variant="success" class="pulse leftPulse"> Vote for Player of the Month</b-button>
                  </template>
                </template>
              </template>
            </div>
          </template>
          <template>
            <div class="">
              <template v-if="pollsource == 'B' || pollsource == 'W' && pollgeneral == 'Y'">
                <template v-if="pollappImage != ''">
                  <template v-if="pollType == 'E'">
                    <b-link @click="pollTypeEclick">
                      <img class="appImageLeft pulse" :src="pollappImage">
                    </b-link>
                  </template>
                  <template v-else>
                    <img class="appImageLeft pulse" v-b-modal.modal-xl :src="pollappImage">
                  </template>
                </template>
                <template v-else>
                  <template v-if="pollType == 'E'">
                    <b-link @click="pollTypeEclick">
                      <b-button variant="success" class="pulse"> Vote for Player of the Month</b-button>
                    </b-link>
                  </template>
                  <template v-else>
                    <b-button v-b-modal.modal-xl variant="success" class="pulse"> Vote for Player of the Month</b-button>
                  </template>
                </template>
              </template>
            </div>
          </template>
        </b-container>
        <b-tabs align="center" class="smallNav">
          <Ads
            class="mobHide secondAd"
            :page="'home'"
            :adNum="'second'"
            :mob="false"
            :side="false"
          />
          <Ads
            class="mobShow"
            :page="'home'"
            :adNum="'second'"
            :mob="true"
            :side="false"
          />

        <!-- Polls Section to test -->
        <b-modal id="modal-xl" size="xl" hide-footer="true">
          <b-container>
            <div v-for="(box, index) in Extradata" :key="index">
              <template v-if="thankyouMessage == 'N'">
                <div >
                  <b-row>
                    <b-col lg="6" sm="12">
                      <template v-if="box.website_video_url !== ''">
                        <template v-if="box.website_video_auto == 'Y'">
                          <iframe allowfullscreen aspect="16by9" muted playsinline allow='autoplay' :src="box.website_video_url + '&autoplay=1'" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <template v-else>
                          <iframe allowfullscreen aspect="16by9" muted playsinline :src="box.website_video_url" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <!-- <b-embed
                          type="iframe"
                          aspect="16by9"
                          :src="box.website_video_url"
                          allowfullscreen
                        ></b-embed> -->
                      </template>
                      <template v-else-if="box.website_image != ''">
                        <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                      </template>
                      <b-modal id="modal-1" title="Terms and Conditions" style="height: 600px; overflow: scroll;">
                        <h3 class="my-4 termsTitle" v-html="docTitle"></h3>
                        <p class="my-4 termsContent" v-html="docContent"></p>
                      </b-modal>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <form class="formSection" ref="formdata">
                        <b-row>
                          <b-col lg="12" sm="12">
                            <p class="boxFull" v-if="box.full_desc != ''" v-html="box.full_desc"></p>
                          </b-col>
                          <!-- <b-col lg="6" sm="12">
                            <p class="boxexpiry" v-if="box.end_date != '' && box.end_time != ''" > Vote expiry date: {{box.end_date}} - {{box.end_time}} ({{timeZone}})</p>
                          </b-col> -->
                        </b-row>
                        <template v-if="box.anonymous == 'N'">
                          <b-row>
                            <b-col lg="5" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polfirstName"
                                  type="name"
                                  placeholder="Enter First Name"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polSurname"
                                  type="name"
                                  placeholder="Enter Surname"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-select v-model="gender" :options="options" ></b-form-select>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <div class="extraPadTop">
                                <b-form-checkbox
                                  id="checkbox-2"
                                  v-model="terms"
                                  name="checkbox-2"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                                >
                                  I accept the <span class="termsandCon" @click="getTermsConditions" v-b-modal.modal-1>terms and conditions</span>
                                </b-form-checkbox>

                                <!-- <div>State: <strong>{{ terms }}</strong></div> -->
                              </div>
                              <!-- <div class="joinFanzon" v-if="box.askfanzone == 'Y'">
                                <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="fanZonejoin"
                                  name="checkbox-1"
                                  value="Y"
                                  unchecked-value="N"
                                >
                                Join Fanzon
                                </b-form-checkbox>

                              </div> -->
                              <div class="deskHide">
                                <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                                <b-row>
                                  <b-col cols="6" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                    <lable v-if="box.multi_select == 'N'">
                                      <span class="titlesCol">
                                        Select one below
                                      </span>
                                    </lable>
                                    <lable v-else>
                                      <span class="titlesCol">
                                        Select one or more below
                                      </span>
                                    </lable>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showvotes == 'Y'">
                                    <span class="titlesCol votes">
                                      Votes
                                    </span>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showpercent == 'Y'">
                                    <span class="titlesCol perc">
                                      %
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                  <b-row>
                                    <template v-if="box.multi_select == 'N'">
                                      <b-col lg="12" sm="12" v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <b-row>
                                          <b-col cols="6" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                              {{op.desc}}
                                            </b-form-radio>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span>{{op.percent}}</span>
                                            </template>
                                          </b-col>
                                        </b-row>
                                      </b-col>
                                    </template>
                                    <template v-else>
                                      <b-col lg="12" sm="12">
                                        <div v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <b-row>
                                          <b-col :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="op.desc">{{op.desc}}</label>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'" class="opt">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span class="percent">{{op.percent}}</span>
                                            </template>                                            
                                          </b-col>
                                        </b-row>
                                        </div>
                                      </b-col>
                                    </template>
                                  </b-row>
                                </b-form-group>
                              </div>
                              <!-- <div class="mt-3">Selected: <strong>{{ Polselected + 1 }}</strong></div> -->
                              <template v-if="polEmail !== '' && polEmail.includes('@') && polfirstName !== '' && polSurname !== '' && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                            <b-col lg="7" sm="12" class="mobHide">
                              <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                              <b-row>
                                <b-col lg="8" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                  <lable v-if="box.multi_select == 'N'">
                                    <span class="titlesCol">
                                      Select one below
                                    </span>
                                  </lable>
                                  <lable v-else>
                                    <span class="titlesCol">
                                      Select one or more below
                                    </span>
                                  </lable>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showvotes == 'Y'">
                                  <span class="titlesCol votes">
                                    Votes
                                  </span>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showpercent == 'Y'">
                                  <span class="titlesCol perc">
                                    %
                                  </span>
                                </b-col>
                              </b-row>
                              <b-form-group label="" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-else>
                          <b-row>
                            <b-col lg="12" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group label="Select one below" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                              <template v-if="polEmail !== '' && polEmail.includes('@') && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                          </b-row>
                        </template>
                        <b-link class="signupText" href="https://ladieseuropeantour.com/news-letter-signup/">Click Here to signup to the fans newsletter</b-link>
                      </form>
                    </b-col>
                  </b-row>
                </div>
              </template>
              <template v-else>
                <b-row>
                  <b-col lg="6" sm="12">
                    <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="voteData.status == 'FAIL'">
                      <h2 class="thankyou" v-html="voteData.message"></h2>
                    </template>
                    <template v-else>
                      <h2 class="thankyou">Thank you for your Vote</h2>
                    </template>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-container>
        </b-modal>

        <!-- End of Polls Section to test -->



          <b-tab active>
            <div id="feature">
              <Post />
            </div>
          </b-tab>
          <b-tab>
            <b-container id="feature">
              <div class="SeeAllVideos">
                <b-link :to="'/videos?id='">
                  <b-button class="socialTitle videosTitle"
                    >See All Videos</b-button
                  >
                </b-link>
              </div>
              <YouTube :id="config.VUE_APP_YOUTUBE_PLAYLIST" />
            </b-container>
          </b-tab>
          <b-tab >
            <div id="feature">
              <b-container>
                <iframe style="border-radius:12px" src="https://open.spotify.com/embed/show/4elkwpxyrREEuvDJHS6y8X?utm_source=generator" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
              </b-container>
            </div>
          </b-tab>
          <b-tab>
            <div id="flickr">
              <Flickr :config="config" />
            </div>
          </b-tab>
        </b-tabs>
        <Ads
          class="mobHide homepage-ad-desktop"
          :page="'home'"
          :adNum="'third'"
          :mob="false"
          :white="true"
          :side="false"
        />
        <div id="banner">
          <b-container>
            <b-row class="adBlock">
              <b-col lg="6" md="6" cols="12">
                <b-link :href="wpHomeacf.acf.banner_one_href" target="_blank">
                  <b-img
                    class="siteBanner"
                    :src="
                      wpHomeacf.acf.banner_one_image
                    "
                  ></b-img>
                </b-link>
              </b-col>
              <b-col lg="6" md="6" cols="12" class="test removeMob">
                <b-nav-item class="BL" :href="wpHomeacf.acf.banner_two_href">
                  <b-img
                    class="siteBanner "
                    :src="
                     wpHomeacf.acf.banner_two_image
                    "
                  ></b-img>
                </b-nav-item>
              </b-col>
            </b-row>
            <!-- <b-row v-if="oom.oom_home_page == 'B' || oom.oom_home_page == 'W'"> -->
            <b-row>
              <b-col>
                <OomSlider
                  :season="season"
                  :oomKey="config.VUE_APP_OOM"
                  :oom="oom"
                  :config="config"
                />
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div id="upComing">
          <!-- <UpComingTours :config="config"/> -->
        </div>
        <div id="flickr">
          <!-- <div style="background-color: white">
          <b-container style="background-color: white">
            <b-link href="https://www.flickr.com/photos/ladieseuropeantour/" target="_blank">
              <b-button v-if="this.$route.name === 'home' " class="allNews">
                See All Photos
              </b-button>
            </b-link>
          </b-container>
          </div> -->
          <Flickr :config="config" />
        </div>
        <!-- <div class="container">
          <parone-video-block hide-title="true" hide-logo="true" hide-description="true" autoplay="true"  :content-key="wpHomeacf.acf.parone_field" stylesheet="undefined" defaultlang="en" feed="49-default-private-feed"></parone-video-block>
        </div> -->
        <Ads
          class="mobHide homepage-ad-desktop"
          :page="'home'"
          :adNum="'foot'"
          :mob="false"
          :white="true"
          :side="false"
        />
        <Ads
          class="mobShow"
          :page="'home'"
          :adNum="'foot'"
          :mob="true"
          :white="true"
          :side="false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Ads from "@/components/ads.vue";
import Post from "@/components/posts.vue";
import Slider from "@/components/slider.vue";
// import Twitter from "@/components/twitterFeed.vue";
// import InstaFeed from "@/components/instaFeed.vue";
// import FaceBook from "@/components/faceBook.vue";
import OomSlider from "@/components/oomSlider.vue";
// import UpComingTours from "@/components/upComingTours.vue";
import Flickr from "@/components/flickr.vue";
import YouTube from "@/components/youTube.vue";
import axios from "axios";
import * as CryptoJS from 'crypto-js';
export default {
  name: "home",
  props: ["course", "season", "report", "title", "config", "currentReport"],
  components: {
    Ads,
    Slider,
    Post,
    // Twitter,
    // InstaFeed,
    // FaceBook,
    OomSlider,
    // UpComingTours,
    Flickr,
    YouTube,
    // SocketServe
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
    cryptoAES: CryptoJSAesJson,
      description: [], //Meta Description
      wpHomeacf: [],
      homepage: true,
      posts:
        this.config.VUE_APP_WPAPI_URL +
        "wp/v2/posts?categories=6&randomadd=" +
        new Date().getTime(),
      sponsor: this.config.VUE_APP_WPAPI_URL + "wp/v2/",
      componentKey: 0,
      oom: [],
      wpHome: [],
      pollData:[],
      polEmail: '',
      polfirstName: '',
      polSurname:'',
      Polselected: '',
      selectedPol:[],
      MultiPolselected: [],
      showbutton: '',
      timeZone: '',
      selectedItems: [],
      showbuttonExtra: [],
      appImage: '',
      // fanZonejoin: 'Y',
      thankyouMessage: 'N',
      voteData: {},
      terms: '',
      docTitle: '',
      docContent:'',
      pollsource: '',
      pollgeneral: '',
      pollMselect: '',
      pollappImage: '',
      Extradata: [],
      pollType: '',
      pollTypeLink: '',
      tourSelect: '',
      gender: null,
      options: [
        { value: null, text: 'Gender' },
        { value: 'M', text: 'Male' },
        { value: 'F', text: 'Female' },
        { value: 'N', text: 'Not Applicable' },
      ]
    };
  },
  methods: {
    base64Decode(input) {
      const decStr = atob(input);
      const bytes = new Uint8Array(decStr.length);

      for (let i = 0; i < bytes.length; i++)
        bytes[i] = decStr.charCodeAt(i);

      return String.fromCharCode(...new Uint16Array(bytes.buffer));
    },
    // Getting Data for polls
    // checkPolls() {
    //   console.log('IN check Polls')
    //   // String 
    //   let polls = "let GNERAL . W"; // GNERAL or email from fanZone, . or Password from fanZone, "W" fixed. 
    //   console.log("polls")
    //   return polls
		// }, 
    getPolls() {
      axios
        .get(
          process.env.VUE_APP_TIC_BASE +
            "tmticx?randomaddText=" +
            new Date().getTime()
        )
        .then(response => {
          this.Extradata = response.data;
          this.pollData = response.data.tm_params.polls;
          if (this.pollData != '') {
            this.showbutton = 'Y'
            if (Array.isArray(response.data.tm_params.polls.polls_entry)) {
              this.Extradata = response.data.tm_params.polls.polls_entry
            } else {
              console.log("is not Array");
              this.Extradata = [response.data.tm_params.polls.polls_entry];
            }
            // let arr = [];
            // console.log("this.arr")
            // console.log(arr)
            // this.Extradata.forEach((value, index) => {
            //     arr.push(value);
            //     console.log(value.source);
            //     console.log(index);
            // });
            this.pollsource = this.pollData.polls_entry.source;
            this.pollgeneral = this.pollData.polls_entry.general;
            this.pollMselect = this.pollData.polls_entry.multi_select;
            this.pollappImage = this.pollData.polls_entry.app_image;
            this.tourSelect = this.pollData.polls_entry.tours.tours_entry[2];
            console.log("this.tourSelect")
            console.log(this.tourSelect)
            this.pollType = this.pollData.polls_entry.type;
            this.pollTypeLink = this.pollData.polls_entry.link_url;
          } else {
            this.showbutton = 'N'
          }
          // if (Array.isArray( this.pollData.polls_entry) ) {
          //   this.showbutton = 'Y'
          //   let arr = [];
          //   this.showbuttonExtra = arr;
          //   this.pollData.polls_entry.forEach((value) => {
          //       if (value.source == 'B' || value.source == 'W') {
          //         arr.push(value.source);
          //         arr.push(value.app_image);
          //         arr.push(value.general);
          //         arr.push(value.multi_select);
          //       }
          //   });
          // } else {
          //   this.showbutton = 'N'
          // }
        })
      // console.log('Get Polls');
      // let sktMsg = this.checkPolls();
      // console.log("sktMsg")
      // console.log(sktMsg)
      // this.$socket.emit('polls', sktMsg, (data) => {
      //   console.log("line 268")
      //   const a = JSON.parse(data)
      //   console.log("pollData")
      //   console.log(a)
      //   this.pollData = a;
      //   if (Array.isArray(this.pollData.polls) ) {
      //     this.showbutton = 'Y'
      //     let arr = [];
      //     this.showbuttonExtra = arr;
      //     this.pollData.polls.forEach((value) => {
      //         if (value.source == 'B' || value.source == 'W') {
      //           arr.push(value.source);
      //           arr.push(value.app_image);
      //           arr.push(value.general);
      //           arr.push(value.multi_select);
      //         }
      //     });
      //   } else {
      //     this.showbutton = 'N'
      //   }
    },
    // Submiting Data for Polls when Anonymous is set to N
    sendPolls() {
      console.log('IN Send Polls')
      // MultiPolselected
      let voteCode = [];
      this.Extradata.forEach((value) => {
          voteCode.push(value.code);
      });
      this.voteCode = voteCode;
      this.selectedPol = this.Polselected + 1;
      let multiSeleted = []
      console.log("multiSeleted")
      console.log(multiSeleted)
      this.selectMulti = multiSeleted;

      this.MultiPolselected.forEach((value) => {
          multiSeleted.push(value);
      });

      if (this.pollMselect == 'Y') {
        console.log('MultiSelect')
				let sendpolls = '';

				sendpolls += 'let' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName.trim() + "<!/D>" + "surname|~" + this.polSurname.trim() + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "gender|~" + this.gender + "<!/D>"
				for (const i of this.selectMulti) {
					sendpolls += 'option_' + (i) + '|~' + 'Y<!/D>';
        }
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        // let sendpolls = "let " + this.polEmail + " . W 'fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + this.leg  + "|~Y<!/D>'"
        return sendpolls 
      } else if(this.pollType == 'E') {
        console.log('Poll Type == E')
        let sendpolls = '';
				sendpolls += 'let' + ' ';
				sendpolls += '.'  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += "code|~" + this.voteCode + "<!/D>";
				sendpolls += 'option_1' + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      } else {
        console.log('NON MultiSelect')
        // let sendpolls = "let " + this.polEmail + '. W' + "'" + "fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "option_" + this.selectedPol + "|~Y<!/D>" + "fz|~" + this.fanZonejoin + "<!/D>" + "'"
        let sendpolls = '';

				sendpolls += 'let' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName.trim() + "<!/D>" + "surname|~" + this.polSurname.trim() + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "gender|~" + this.gender + "<!/D>"
				sendpolls += 'option_' + this.selectedPol + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      }
		}, 
    pollTypeEclick() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      console.log('Send Poll Data -- E')
      // this.$socket.emit('vote', sktMsg);
      this.$socket.emit('vote', sktMsg, (data) => {
        const jsonDoc = JSON.parse(data);
        this.voteData = jsonDoc;
        console.log("data")
        console.log(data)
      });
      window.open(this.pollTypeLink, '_blank');
    },
    sendPollsData() {
      let sktMsg = this.sendPolls()
      this.$socket.emit('vote', sktMsg, (data) => {
        const jsonDoc = JSON.parse(data);
        this.voteData = jsonDoc;
        console.log("data")
        console.log(data)
      });
      // this.$socket.emit('vote', sktMsg);
      this.thankyouMessage = 'Y' 
    },
    getTermsConditions: function() {
      axios
        .get(
          "https://ocs-let.com/apps/marketing-terms.php?action=latest&tour=" + 'let' + "&?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          // this.showTerms = 'Y';
          // console.log("this.showTerms")
          // console.log(this.showTerms)
          this.docTitle = this.base64Decode(response.data.documents.document.title);
          console.log("this.docTitle")
          console.log(this.docTitle)
          this.docContent = this.base64Decode(response.data.documents.document.content);
          console.log("this.docContent")
          console.log(this.docContent)
        });
    },
    // Submiting Data for Polls when Anonymous is set to Y
    // sendPollsY() {
    //   console.log('IN Send Polls')
    //   let voteCode = [];
    //   this.pollData.polls.forEach((value) => {
    //       voteCode.push(value.code);
    //   });
    //   this.voteCode = voteCode;
    //   this.selectedPol = this.Polselected + 1;

    //   let multiSeleted = []
    //   console.log("multiSeleted")
    //   console.log(multiSeleted)
    //   this.selectMulti = multiSeleted;

    //   this.MultiPolselected.forEach((value) => {
    //       multiSeleted.push(value);
    //   });


    //   if (this.showbuttonExtra[3] == 'Y') {
    //     console.log('MultiSelect')
		// 		let sendpolls = '';

		// 		sendpolls += 'let' + ' ';
		// 		sendpolls += "."  + ' ';
		// 		sendpolls += '. W ';
    //     sendpolls += "'";
		// 		sendpolls += 'fname|~' + "." + "<!/D>" + "surname|~" + "." + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
		// 		for (const i of this.selectMulti) {
		// 			sendpolls += 'option_' + (i) + '|~' + 'Y<!/D>';
    //     }
    //     sendpolls += "'";
    //     // let sendpolls = "let " + this.polEmail + " . W 'fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + this.leg  + "|~Y<!/D>'"
    //     return sendpolls 
    //   } else {
    //     console.log('NON MultiSelect')
    //     let sendpolls = '';

		// 		sendpolls += 'let' + ' ';
		// 		sendpolls += '.' + ' ';
		// 		sendpolls += '. W ';
    //     sendpolls += "'";
		// 		sendpolls += 'fname|~' + '.' + "<!/D>" + "surname|~" + '.' + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
		// 		sendpolls += 'option_' + this.selectedPol + '|~' + 'Y<!/D>';
    //     sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
    //     sendpolls += "'";
    //     return sendpolls
    //   }
		// }, 
    // sendPollsDataY() {
    //   let sktMsg = this.sendPollsY()
    //   console.log("sktMsg")
    //   console.log(sktMsg)
    //   this.$socket.emit('vote', sktMsg, (data) => {
    //     this.voteData = data;
    //     console.log("data")
    //     console.log(data)
    //   });
    //   this.thankyouMessage = 'Y' 
    // },
    callSpotify: function() {
      window.open("https://open.spotify.com/show/4elkwpxyrREEuvDJHS6y8X");
    },
    getOOM(oomSeason) {
        axios.get(
          process.env.VUE_APP_TIC_BASE +
            oomSeason +
            "/" +
            oomSeason +
            "-ooms-oom-" +
            process.env.VUE_APP_OOM +
            ".json?randomadd=" +
            new Date().getTime()
        )
        .then(response => {
          this.oom = response.data;
          if (this.oom.oom_available != 'Y') {
           this.getOOM(oomSeason - 1) 
          }
        });
    }
  },
  computed: {
    takeOver: function(take) {
      if (this.wpHome === false) take = false;
      else take = true;
      return take;
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_WPAPI_URL + "wp/v2/pages/9")
      .then(response => {
        this.wpHome = response.data.acf.takeover_page;
        this.wpHomeacf = response.data;
        this.timeZone = localStorage.getItem("timezone");
        this.$emit("takeover", { takeover: this.wpHome });
        this.getOOM(this.season);
        this.getPolls();
        // this.postFanselect();
      })
  }
};
</script>
<style scoped>
.signupText {
    font-size: 13pt;
    color: #00477c;
    margin-top: 10px;
    display: block;
}
select.custom-select {
    color: #6c757d;
    opacity: 1;
    margin-bottom: 15px;
}
::v-deep .modal-footer {
  display: none!important;
}
span.titlesCol.perc {
    position: relative;
    left: 16px;
    font-weight: bold;
}
span.titlesCol.votes {
    position: relative;
    left: -11px;
}
span.titlesCol {
    font-weight: 600;
    text-align: center;
    margin: auto;
}
.col-lg-8.nameWidth {
    flex: 0 0 80%;
    max-width: 80%;
}
.col-6.nameWidth {
    flex: 0 0 70%;
    max-width: 70%;
}
.percent {
  position: absolute;
  right: -80px;
  top: 0px;
}
@media (min-width: 1200px) {
  .modal-dialog.modal-xl {
    max-width: 1350px!important;
  }
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
div#modal-1___BV_modal_content_ {
    height: 600px;
    overflow: scroll;
}
span.termsandCon {
  text-decoration: underline;
}
h2.thankyou {
  color: #00477c;
  text-align: center;
  margin-top: 120px;
}
.extraPadTop {
  padding-top: 10px;
}
.opt {
  position: absolute;
  right: 0;
  top: 0;
}
.multiLable {
  padding-left: 15px;
}
.appImage {
  width: 300px;
  position: absolute;
  right: 12em;
  margin-top: 18px;
}
.appImageLeft {
  width: 300px;
  position: absolute;
  left: 11em;
  margin-top: 18px;
}
button.btn.pulse.leftPulse.btn-success {
  position: absolute;
  left: 14em;
}
::v-deep header#modal-xl___BV_modal_header_ {
  display: none!important;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: none!important;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 255, 131, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
button.btn.btn-success {
  position: absolute;
  right: 14em;
  margin-top: 27px;
  width: 300px;
  height: 50px;
}
button.btn.buttonVote.des.btn-secondary.disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}
p.boxFull {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 0px;
}
.boxexpiry {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 30px;
}
.formSection {
  padding-top: 30px;
  background: white;
  padding: 40px;
  font-size: 13pt;
  color: #00477c;
  padding-top: 0px;
}
.votePicture {
  width: 100%;
}
.buttonVote {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #01477b;
  margin-top: 20px;
}
.playerofMonth {
  font-size: 2rem;
  color: #01477b;
  font-weight: 400;
  padding-bottom: 20px;
}
.TestClass {
  color: #01477b;
}
::v-deep .allNews:hover {
  float: right;
  background-color: #015699;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #015699;
}
div#flickr {
  padding-top: 20px;
}
.smallNav > div {
  height: 120px;
}
.homeBottom {
  margin-bottom: -30px;
}
.SeeAllVideos {
  margin-bottom: 50px;
}
::v-deep .smallNav > div > ul {
  height: 105px;
}
.allNews {
  float: right;
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-top: -48px;
  border-color: #01477b;
}
.adBlock {
  /* margin-bottom: 40px; */
  margin-bottom: 0px;
  margin-top: -5px;
}
::v-deep .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: transparent !important;
}
.videosTitle {
  margin-right: 30px;
  margin-bottom: 2em;
}
.mobHide.secondAd {
  margin-top: 2em;
  margin-bottom: -3em;
}
.home.container {
  padding-top: 20px;
}
.spacer {
  height: 150px;
}
.smallNav {
  width: 100%;
  left: 0;
  margin: 0;
  /* background-color: white; */
}
.social {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
}
.socialTitle {
  float: right;
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
}
#banner {
  padding: 100px 0;
  /* background-color: white; */
  padding-top: 0px;
}

.siteBanner {
  width: 100%;
}
.home {
  /* background-color: #f1f1f1; */
}
#feature {
  /* padding: 50px 0 100px 0; */
  padding: 50px 0 7px 0;
  /* background-color: white; */
}
#social {
  padding: 100px;
}
.homepage-ad-desktop {
  margin-bottom: 50px;
}
::v-deep .nav-item {
  display: flex;
  align-items: center;
  padding-top: 7px;
}
::v-deep .col-md-10 {
  display: flex;
  align-items: center;
  padding-top: 7px;
}
::v-deep .fa-instagram {
  color: #cc4666;
}
.title {
  color: #133f7b;
}
::v-deep .nav-tabs > li:nth-child(1) {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2023/09/News_White_2023.png);
  width: 80px;
  height: 120px;
  background-size: 75px;
  background-repeat: no-repeat;
}
::v-deep .nav-tabs > li:nth-child(1):hover {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2023/09/News_Blue_2023.png);
}
::v-deep .nav-tabs > li:nth-child(2) {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2023/09/Videos_White_2023.png);
  width: 80px;
  height: 120px;
  background-size: 75px;
  background-repeat: no-repeat;
}
::v-deep .nav-tabs > li:nth-child(2):hover {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2023/09/Videos_Blue_2023.png);
}
::v-deep .nav-tabs > li:nth-child(3) {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2024/03/PodCast_White_2024_new.png);
  width: 80px;
  height: 120px;
  background-size: 75px;
  background-repeat: no-repeat;
}
::v-deep .nav-tabs > li:nth-child(3):hover {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2024/03/PodCast_Blue_2024-_new.png);
}
::v-deep .nav-tabs > li:nth-child(4) {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2023/09/Photos_White_2023.png);
  width: 80px;
  height: 120px;
  background-size: 75px;
  background-repeat: no-repeat;
}
::v-deep .nav-tabs > li:nth-child(4):hover {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2023/09/Photos_Blue_2023.png);
}
::v-deep .nav-tabs > .nav-item > .nav-link {
  width: 100%;
  height: 100%;
}
::v-deep .nav-tabs > .nav-item > .nav-link.active {
  background-color: transparent;
  border-color: transparent;
}
::v-deep .nav-tabs {
  background-color: #015699;
  border-bottom: 0px solid #dee2e6;
}
.BL {
  padding: 0;
}
.BL > .nav-link {
  padding: 0;
}
.mobHide {
  display: block;
}
.mobShow {
  display: none;
}
.AdPadTest {
  padding: 30px 0px;
  min-width: 970px; 
  min-height: 50px;
}
.AdPadTestImage {
  margin:auto; 
  display:block; 
  width: 970px; 
}
@media only screen and (max-width: 1400px) {
  .appImageLeft {
    display: none;
  }
  .appImage {
    width: 100%;
    position: inherit;
    right: 12em;
    margin-top: 0px;
  }
  .nocon {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      display: contents;
  }
}
@media only screen and (min-width: 769px) {
  .deskHide{
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  span.titlesCol.perc {
    position: relative;
    left: 0!important;
    font-weight: 700;
  }
  .extraPadTop {
    padding-top: 0px;
    padding-bottom: 20px;
  }
  .formSection {
    padding-top: 30px;
    background: white;
    padding: 0;
    font-size: 13pt;
    color: #00477c;
    padding-top: 30px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
  }
  .appImage {
    width: 100%;
    position: initial;
    margin-top: 0;
  }
  .home.container.nopadMod {
    padding: 0px;
    background-color: #fff;
  }
  .mobHide {
    display: none;
  }
  .mobShow {
    display: block;
  }
  ::v-deep #oomSlider {
    padding-top: 380px;
    margin-top: 10em;
  }
}

@media only screen and (max-width: 425px) {
    .removeMob {
      display: none;
    }
    #social {
      padding: 10px;
    }
    .siteBanner {
      padding: 10px;
    }
    #banner {
      padding: 40px 0;
      /* background-color: white; */
      padding-top: 0px;
    }
    #feature {
      padding: 50px 0 50px 0;
    }
    #oomSlider {
      padding-top: 470px;
    }
    .AdPadTest {
      padding: 15px 0px;
      min-width: 320px; 
      min-height: 50px;
    }
    .AdPadTestImage {
      margin:auto; 
      display:block; 
      width: 320px; 
    }
}
@media only screen and (max-width: 375px) {
  #oomSlider {
    margin-top: 10em;
  }
}
</style>
